import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import * as React from 'react';

import { AdBannerMicrofrontendContainer } from '../AdBannerMicrofrontendContainer';
import { useTgbParameters } from './hooks/useTgbParameters';

interface IAdBannerMicrofrontendTgbContainerProps {
  manifest: IMicrofrontendManifest;
  position: number;
  isNewbuilding: boolean;
  onStub?: () => void;
  onError?: () => void;
  onClose?: () => void;
}

/**
 * Place-контейнер TGB-баннера между объявлениями: поставляет параметры места
 * и рендерит generic-контейнер.
 */
export const AdBannerMicrofrontendTgbContainer: React.FC<IAdBannerMicrofrontendTgbContainerProps> = ({
  manifest,
  position,
  isNewbuilding,
  onStub,
  onError,
  onClose,
}) => {
  const parameters = useTgbParameters({ position, isNewbuilding });

  return (
    <AdBannerMicrofrontendContainer
      manifest={manifest}
      parameters={parameters}
      onStub={onStub}
      onError={onError}
      onClose={onClose}
    />
  );
};
